/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import Vue from 'vue';
import store from '@/store';
import AuthApi from '@/api/AuthApi';
import Axios from 'axios';
import { router } from '../../../plugins/vue-router';
import * as types from './mutation-types';

/**
 * Action which will check the authentication.
 *
 * @param {function} commit Commit function to update the store.
 */
// export const checkDeskDaf = ({ commit }) => {
//   Axios.get('/').then((res) => {
//     // check headers to redirect on the good admin
//     console.log(res.headers);
//     if (res.headers['x-edoc-app'] === 'desk-daf') {
//       commit(types.LOGOUT);
//       router.push({ name: 'loginDeskDaf.index' });
//     }
//     if (res.headers['x-edoc-app'] === 'desk-rh' && !localStorage.getItem('')) {
//       commit(types.LOGOUT_DESKDAF);
//       router.push({ name: 'login.index' });
//     }
//   });
//   commit(types.CHECK);
//   commit(types.CHECK_DESKDAF);
// };

// export const check = ({ commit }) => {
//   Axios.get('/').then((res) => {
//     if (res.headers['x-edoc-app'] === 'edoc-sign' && !localStorage.getItem('sessionEdocSign')) {
//       commit(types.LOGOUT);
//       router.push({ name: 'loginEdocSign.index' });
//     }
//     if (res.headers['x-edoc-app'] === 'desk-rh' && !localStorage.getItem('session')) {
//       commit(types.LOGOUT_EDOCSIGN);
//       router.push({ name: 'login.index' });
//     }
//   });
//
//   commit(types.CHECK_EDOCSIGN);
//   commit(types.CHECK);
// };

export const check = ({ commit }) => {
  Axios.get('/').then((res) => {
    console.log(res.headers);
    if (res.headers['x-edoc-app'] === 'edoc-sign' && !localStorage.getItem('sessionEdocSign')) {
      commit(types.LOGOUT);
      commit(types.LOGOUT_DESKDAF);
      router.push({ name: 'loginEdocSign.index' });
    }
    if (res.headers['x-edoc-app'] === 'desk-rh' && !localStorage.getItem('session')) {
      commit(types.LOGOUT_EDOCSIGN);
      commit(types.LOGOUT_DESKDAF);
      router.push({ name: 'login.index' });
    }
    if (res.headers['x-edoc-app'] === 'desk-daf' && !localStorage.getItem('sessionDeskDaf')) {
      commit(types.LOGOUT);
      commit(types.LOGOUT_EDOCSIGN);
      router.push({ name: 'loginDeskDaf.index' });
    }
  });
  commit(types.CHECK);
  commit(types.CHECK_DESKDAF);
  commit(types.CHECK_EDOCSIGN);
};

/**
 * Action which will try to login the user.
 *
 * @param {function} commit  Commit function to update the store.
 * @param {Object}   payload The payload.
 */
export const loginOnDomain = ({ commit }, payload) => AuthApi.login(payload).then((response) => {
  if (payload.domain) localStorage.setItem('domainConnected', JSON.stringify(payload.domain));
  const session = {
    token: response.headers['set-authorization'],
    login: response.data.data.login,
    orgId: response.data.data.userOrgId,
    features: response.data.data.features,
  };
  commit(types.LOGIN, session);
  return session;
});

export const login = ({ commit }, payload) => {
  store.dispatch('application/startLoading');
  AuthApi.login(payload)
    .then((response) => {
      store.dispatch('application/finishLoading');
      if (response.headers['set-authorization']) {
        const session = { token: response.headers['set-authorization'], login: response.data.data.login, orgId: response.data.data.userOrgId, features: response.data.data.features };
        commit(types.LOGIN, session);
        Vue.router.push({
          name: 'organizations.index',
        });
        return session;
      }
      if (response.data.data && Array.isArray(response.data.data) && response.data.data[0].domain) {
        commit(types.DOMAINS, response.data.data);
        commit(types.LOGIN_ADMIN_DRH_CREDENTIALS, payload);
        Vue.router.push({
          name: 'organizations.index',
        });
        return null;
      }
      store.dispatch('application/openSnackbar', {
        message: 'Erreur d\'identification, ',
      });
      return Promise.reject('Erreur d\'identification, ');
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Erreur d\'identification, vérifiez votre login et votre mot de passe',
      });
      return Promise.reject(error);
    });
};

export const resetDeskRHSession = ({ commit }) => commit(types.RESET_DRH_SESSION);

/**
 * Action which will try to logout the user.
 *
 * @param {function} commit Commit function to update the store.
 */
export const logout = ({ commit }) => {
  commit(types.LOGOUT);
  Vue.router.push({
    name: 'login.index',
  });
};

/**
 * Action which will login the user to DeskDaf
 */

// function as login edoc-sign

// export const loginDeskDaf = ({ commit }, payload) => {
//   store.dispatch('application/startLoading');
//   AuthApi.loginDeskDaf(payload)
//     // eslint-disable-next-line consistent-return
//     .then((response) => {
//       console.log(response);
//       if (response.data.status !== 'warn') {
//         store.dispatch('application/finishLoading');
//         commit(types.LOGIN_DESKDAF, response.data.data.sessionId);
//         Vue.router.push({
//           name: 'organizations.index',
//         });
//       } else {
//         store.dispatch('application/openSnackbar', {
//           message: 'Erreur d\'identification, ',
//         });
//         return Promise.reject('Erreur d\'identification, ');
//       }
//     })
//     .catch((error) => {
//       store.dispatch('application/finishLoading');
//       store.dispatch('application/openSnackbar', {
//         message: 'Erreur d\'identification, vérifiez votre login et votre mot de passe',
//       });
//       return Promise.reject(error);
//     });
// };

export const loginDeskDaf = ({ commit }, payload) => {
  store.dispatch('application/startLoading');
  AuthApi.loginDeskDaf(payload)
    .then((response) => {
      store.dispatch('application/finishLoading');
      if (response.headers['set-authorization']) {
        const session = { token: response.headers['set-authorization'], login: response.data.data.login, orgId: response.data.data.userOrgId, features: response.data.data.features };
        commit(types.LOGIN_DESKDAF, session);
        Vue.router.push({
          name: 'organizations.index',
        });
        return session;
      }
      store.dispatch('application/openSnackbar', {
        message: 'Erreur d\'identification, ',
      });
      return Promise.reject('Erreur d\'identification, ');
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Erreur d\'identification, vérifiez votre login et votre mot de passe',
      });
      return Promise.reject(error);
    });
};


/**
 * Action which will logout the user to DeskDaf
 */
export const logoutDeskDaf = ({ commit }) => {
  commit(types.LOGOUT_DESKDAF);
  Vue.router.push({
    name: 'loginDeskDaf.index',
  });
};

/**
 * Action which will try to login the user.
 *
 * @param {function} commit  Commit function to update the store.
 * @param {Object}   payload The payload.
 */
export const loginEdocSign = ({ commit }, payload) => {
  store.dispatch('application/startLoading');
  AuthApi.loginEdocSign(payload)
    // eslint-disable-next-line consistent-return
    .then((response) => {
      if (response.data.status !== 'warn' && response.data.status !== 'error') {
        store.dispatch('application/finishLoading');
        commit(types.LOGIN_EDOCSIGN, response.data.data.sessionId);
        Vue.router.push({
          name: 'users.index',
        });
      } else {
        store.dispatch('application/openSnackbar', {
          message: 'Erreur d\'identification, ',
        });
        return Promise.reject('Erreur d\'identification, ');
      }
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Erreur d\'identification, vérifiez votre login et votre mot de passe',
      });
      return Promise.reject(error);
    });
};

/**
 * Action which will try to logout the user.
 *
 * @param {function} commit Commit function to update the store.
 */
export const logoutEdocSign = ({ commit }) => {
  commit(types.LOGOUT_EDOCSIGN);
  Vue.router.push({
    name: 'loginEdocSign.index',
  });
};

export default {
  check,
  login,
  loginOnDomain,
  logout,
  loginDeskDaf,
  logoutDeskDaf,
  loginEdocSign,
  logoutEdocSign,
  resetDeskRHSession,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js